import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Alert, Container, Spinner } from 'react-bootstrap';
import { useSystemOptionsStore } from '../stores/useOptions';
import { useUserAdminStore } from '../stores/userAdmin';

const VotingStatusCheck = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const { systemOptions } = useSystemOptionsStore();
  const { userAdmin } = useUserAdminStore();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      if (systemOptions.votacionActiva === 0 && 
          !userAdmin.login && 
          !pathname.includes('iniciarsesionadmin')) {
        navigate('/');
      }
    }, 1000); // Simula una carga de 1 segundo

    return () => clearTimeout(timer);
  }, [systemOptions.votacionActiva, userAdmin.login, pathname, navigate]);

  if (loading) {
    return (
      <Container className="mt-4 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </Container>
    );
  }

  if (systemOptions.votacionActiva === 0) {
    return (
      <Container className="mt-4 mb-4">
        <Alert variant="danger">
          <Alert.Heading>
            <i className="bi bi-exclamation-triangle me-2"></i>
            Votación Finalizada
          </Alert.Heading>
          <p className="mb-0">
            El período de votación ha concluido. Gracias por tu participación.
          </p>
        </Alert>
      </Container>
    );
  }

  return null;
};

export default VotingStatusCheck;